import { Tooltip } from 'antd'
import classNames from 'classnames'
import { MyForm } from '~/components/ui/MyForm'
import { MyIcon } from '~/components/ui/MyIcon'
import GridSelect from '../GridSelect'
import { QuestionCircleOutlined } from '@ant-design/icons'
import styles from '../AiForm.module.css'
import useOptions from './useOptions'
import { useAtom } from 'jotai'
import { characterAtom } from './atom'

export const CharacterComp = () => {
  const { characterOptions } = useOptions()
  const [character, setCharacter] = useAtom(characterAtom)

  return (
    <>
      <div className="w-full flex justify-between items-center mb-1">
        <span>
          角色同人{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="创作中会加入选中的角色同人特征；选项名称前有（负向）时，创作会规避该角色同人的特征"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
        <a
          href="https://support.wujiebantu.com/qa/pt.html"
          target="_blank"
          rel="noreferrer"
          className="flex items-center text-xs pl-2 pr-0.5 rounded-3xl bg-[#281A54] text-primary"
        >
          使用说明
          <MyIcon icon="arrow-right-simple" className="text-[20px]" />
        </a>
      </div>

      <MyForm.Item className={classNames(styles.borderLessFormItem, '!mb-8')}>
        <GridSelect
          value={character}
          onChange={val => setCharacter(val as string[])}
          placeholder="请选择角色同人"
          options={characterOptions}
        />
      </MyForm.Item>
    </>
  )
}
